import { clsx } from 'clsx';
import { useEffect } from 'react';
import { lockBackgroundScroll, unlockBackgroundScroll } from '../../utils/lockBackgroundScroll';
import closeDialogIcon from '../../../assets/icons/close-dialog-icon.svg';
import styles from './Modal.scss';

interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  withCloseButton?: boolean;
  className?: string;
}

const Modal = ({ isOpen, children, onClose, withCloseButton = false, className = '' }: ModalProps) => {
  useEffect(() => {
    if (isOpen) {
      lockBackgroundScroll();
    } else {
      unlockBackgroundScroll();
    }
  }, [isOpen]);

  const handleClose = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return isOpen ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- modal overlay instinctive click
    <div aria-modal className={styles.overlay} onClick={handleClose}>
      <div className={clsx(styles.modal, className)}>
        {withCloseButton && (
          <button type="button" className={styles.closeDialogButton} title="Close download modal" onClick={onClose}>
            <img src={closeDialogIcon} alt="Close pop-up button" width="16" height="16" />
          </button>
        )}
        {children}
      </div>
    </div>
  ) : null;
};

export default Modal;
